var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useConfirmDialog } from "@/composables/confirmDialog";
import { useNotificationsStore } from "@/stores/notificationsStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import NotificationCard from "@/components/Notifications/NotificationCard.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsPanel',
    setup(__props) {
        library.add(faCheckDouble);
        const { confirm } = useConfirmDialog();
        const notificationsStore = useNotificationsStore();
        const { notifications, loadingNotifications } = storeToRefs(notificationsStore);
        const unreadNotifications = computed(() => {
            return notifications.value.filter((notification) => !notification.seen_time);
        });
        function onMarkAllAsRead() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to mark all unread notifications as read?", {
                    title: "Mark all unread notifications as read?",
                });
                if (confirmed) {
                    yield notificationsStore.updateBatchNotification({
                        notification_ids: unreadNotifications.value.map((n) => n.id),
                        changes: { seen: true },
                    });
                }
            });
        }
        return { __sfc: true, confirm, notificationsStore, notifications, loadingNotifications, unreadNotifications, onMarkAllAsRead, faCheckDouble, FontAwesomeIcon, BAlert, BButton, BButtonGroup, LoadingSpan, NotificationCard, ActivityPanel };
    }
});
